import React from 'react';

import { useCurrentUserEmployer } from 'src/hooks/employer';

import { DashboardReportsMetrics } from './DashboardReportsMetrics';

export const DashboardReportsEmpAdmin: React.FC = () => {
  const { employerId, employer, loading } = useCurrentUserEmployer();

  return (
    <DashboardReportsMetrics
      employerIds={[employerId || '']}
      createdAtCompany={employer?.createdAt}
      loading={loading}
    />
  );
};
